import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import { Stat } from '@Common/models';
import { GC_STAT_DRAWER_DEFAULT_TEXT, GRAMMAR_STATS } from '@Common/constants';
import { GrammarCheckerStats } from '../models/store';
import { getReadability, getReadingTime, getSentiment } from '../utils';

const StatisticsDrawer = dynamic(() => import('src/_common/components/drawer/StatisticsDrawer'), {
  ssr: false,
});

const GCStatsDrawer = () => {
  const [stats, setStats] = useState<Stat[]>([]);
  const isGrammarCheckRunning: boolean = useSelector(
    (state: RootState) => state?.grmr?.controls?.isGrammarCheckRunning
  );
  const inputText: string = useSelector((state: RootState) => state?.grmr?.input?.inputText);
  const numOfWords: number = useSelector((state: RootState) => state?.grmr?.input?.wordCount);
  const numOfErrors: number = useSelector((state: RootState) => state?.grmr?.input?.grammarError);

  const calculateStats = () => {
    const statValues: GrammarCheckerStats = {
      totalErrors: 0,
      errorPercentage: '-',
      readability: '-',
      readingTime: '-',
      sentiment: '-',
    };

    if (isGrammarCheckRunning) {
      return;
    }

    if (inputText === '') {
      setStats([]);
      return;
    }

    const errorPercentage = numOfWords !== 0 ? Math.round((numOfErrors / numOfWords) * 100) : 0;
    statValues.totalErrors = numOfErrors;
    statValues.errorPercentage = `${errorPercentage}%`;
    statValues.readability = getReadability(inputText);
    statValues.readingTime = getReadingTime(numOfWords);
    statValues.sentiment = getSentiment(inputText);

    const statsArray: Stat[] = [];
    GRAMMAR_STATS.forEach((stat) => {
      stat.value = statValues[stat.key];
      statsArray.push(stat);
    });
    setStats(statsArray);
  };

  useEffect(() => {
    calculateStats();
  }, [isGrammarCheckRunning, inputText, numOfErrors]);

  return <StatisticsDrawer stats={stats} showStats defaultText={GC_STAT_DRAWER_DEFAULT_TEXT} />;
};

export default GCStatsDrawer;
